import { Notice } from '../../Model/Notice';
import { NoticeRepository, CreateNoticeDTO } from '../Repositories/NoticeRepository';

export class UpdateNoticeUseCase {
  constructor(private repo: NoticeRepository) {}
  execute(id: number, dto: Partial<CreateNoticeDTO>): Promise<Notice> {
    return this.repo.update(id, dto).then(r => r).catch(err => Promise.reject(err));
  }
}
